module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "black_belt_cover.6db2451f.jpg";